var routeLayer = function(map, roadDataList, options, clickCallback) {
  let p = options.pianyi ? 0.001 : 0;
  this._map = map;
  this._options = options;
  this._pianyi = p;
  this._roadDataList = roadDataList;
  this._clickCallback = clickCallback;
  var draw = this.draw.bind(this);
  map.addEventListener("zoomend", draw);
  this.removeListener = function() {
    map.removeEventListener("zoomend", draw);
  };
};

routeLayer.prototype.clear = function() {
  this.clearLastChoose();
  if (this._polylineArr) {
    for (let i of this._polylineArr) {
      this._map.removeOverlay(i);
    }
    this._polylineArr = null;
  }
};
routeLayer.prototype.remove = function() {
  this.clear();
  this.removeListener();
};

routeLayer.prototype.draw = function(e) {
  this.clear();
  let polylineArr = [];

  for (let roadData of this._roadDataList) {
    for (let item of roadData.points) {
      var arr = [];
      for (let item2 of item) {
        arr.push(
          new BMap.Point(item2[0] - this._pianyi, item2[1] - this._pianyi)
        );
      }
      var polyline = new BMap.Polyline(arr, {
        strokeColor: roadData[this._options.sensortype + "_color"],
        strokeWeight: getPixelDistance(roadData.width_m, this._map) / 400,
        strokeOpacity: this._options.opacityValue,
        strokeStyle: this._options.dashed ? "dashed" : "solid",
        fillColor: roadData[this._options.sensortype + "_color"]
      });
      if (this._clickCallback) {
        polyline.addEventListener("click", () => {
          this._chooseRoute = roadData;
          this._clickCallback(roadData);
          this.showChooseRoute();
        });
      }
      this._map.addOverlay(polyline);
      polylineArr.push(polyline);
    }
  }
  this._polylineArr = polylineArr;
  this.showChooseRoute();
};

routeLayer.prototype.showChooseRoute = function() {
  this.clearLastChoose();
  if (!this._chooseRoute) {
    return;
  }
  for (let point of this._chooseRoute.points) {
    let arr = [];
    for (let item2 of point) {
      arr.push(
        new BMap.Point(item2[0] - this._pianyi, item2[1] - this._pianyi)
      );
    }
    let polyline = new BMap.Polyline(arr, {
      strokeColor: this._chooseRoute[this._options.sensortype + "_color"],
      strokeWeight:
        getPixelDistance(this._chooseRoute.width_m, this._map) / 400,
      strokeOpacity: this._options.opacityValue,
      strokeStyle: this._options.dashed ? "dashed" : "solid"
    });
    let polylineWrap = new BMap.Polyline(arr, {
      strokeColor: "rgb(19, 159, 232)",
      strokeWeight:
        getPixelDistance(this._chooseRoute.width_m, this._map) / 160,
      strokeOpacity: this._options.opacityValue,
      strokeStyle: this._options.dashed ? "dashed" : "solid"
    });
    this._map.addOverlay(polylineWrap);
    this._map.addOverlay(polyline);
    this._chooseLine = [polyline, polylineWrap];
    polyline.addEventListener("click", this.clearLastChoose);
    polylineWrap.addEventListener("click", this.clearLastChoose);
  }
};

routeLayer.prototype.clearLastChoose = function() {
  if (this._chooseLine) {
    for (let i of this._chooseLine) {
      this._map.removeOverlay(i);
    }
  }
};

function getPixelDistance(fkm, map) {
  if (!fkm) {
    return 1;
  }
  var ptt = new BMap.Point(117, 36);
  var ptt2 = new BMap.Point(117, 36 + fkm * 0.01); //0.3km
  var p1 = map.pointToPixel(ptt);
  var p2 = map.pointToPixel(ptt2);
  var R = Math.sqrt(
    (p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y)
  );
  return R;
}

export default routeLayer;
